import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Col } from 'antd';
import { Helmet } from 'react-helmet';

import placeHolderImage from './images/ComingSoon.svg';

import { ErrorContainer, ErrorSubtitle, ErrorTitle, Image, MainContainer, StyledCol, StyledRow } from './ComingSoon.styles';

const ComingSoon = () => {
  return (
    <>
      <Helmet>
        <title>New Feature Coming Soon</title>
      </Helmet>
      <MainContainer>
        <StyledRow type="flex" align="middle">
          <StyledCol span={24} md={10}>
            <Image src={placeHolderImage} alt="coming-soon-page" />
          </StyledCol>
          <Col span={0} md={1} />
          <StyledCol span={24} md={11}>
            <ErrorContainer>
              <ErrorTitle>Coming Soon!</ErrorTitle>
              <ErrorSubtitle>This page is coming soon! We are working very hard on the new feature on our platform. Stay tuned!</ErrorSubtitle>
              <Button type="primary" size="large" style={{ width: 'auto', margin: '0 auto' }}>
                <Link to="/">Go Back</Link>
              </Button>
            </ErrorContainer>
          </StyledCol>
        </StyledRow>
      </MainContainer>
    </>
  );
};

export default ComingSoon;
